import { render, staticRenderFns } from "./share-timeout-order.vue?vue&type=template&id=13e0c966&scoped=true"
import script from "./share-timeout-order.vue?vue&type=script&lang=js"
export * from "./share-timeout-order.vue?vue&type=script&lang=js"
import style0 from "./share-timeout-order.vue?vue&type=style&index=0&id=13e0c966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e0c966",
  null
  
)

export default component.exports